import { useMemo } from 'react'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import useMerchandiseCategoriesList from 'hooks/Merchandise/useMerchandiseCategoriesList'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import qs from 'qs'
import { FormattedMessage } from 'react-intl'

interface Props {
  categoryName?: string
  categoryId?: string
  trackingPageName: string
}

function MerchandiseBestOfCategoryCarousel({ trackingPageName, categoryName, categoryId }: Props) {
  const [categoriesList] = useMerchandiseCategoriesList({ name: categoryName }, { disabled: !categoryName })
  const categoryIdToUse = categoryId ?? categoriesList[0]
  const [category] = useMerchandiseCategory({ id: categoryIdToUse }, { disabled: !categoryIdToUse })

  const filters = useMemo(() => {
    if (!category) return
    return {
      categories: [category?.id],
    }
  }, [category])

  const titleConfig = useMemo<{ node: React.ReactNode; tracking: string }>(() => {
    if (!category) {
      return { node: null, tracking: '' }
    }

    switch (category.name) {
      case 'Home & Garden':
        return {
          node: (
            <FormattedMessage
              id="hEqdey76lXtHPMRJs-XW"
              defaultMessage="Best of <em>{categoryName}</em>"
              description="Heading title for Home & Garden category carousel in the merchandise shop section"
              values={{
                categoryName: category.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Best of ${category.name}`,
        }
      case 'Electronics':
        return {
          node: (
            <FormattedMessage
              id="Ccu3HU-bhPAB7Oz7B6hU"
              defaultMessage="Top tech in <em>{categoryName}</em>"
              description="Heading title for Electronics category carousel in the merchandise shop section"
              values={{
                categoryName: category.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Top tech in ${category.name}`,
        }
      default:
        return {
          node: (
            <FormattedMessage
              id="OBYz_D8H59GDPM-ckHNm"
              defaultMessage="Discover the best of <em>{categoryName}</em>"
              description="Heading title for merchandise category carousel (default)"
              values={{
                categoryName: category.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Discover the best of ${category.name}`,
        }
    }
  }, [category])

  if (!category || (categoryName && category.name !== categoryName)) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={titleConfig.node}
      viewAllTo={`/search/shop?${qs.stringify(filters)}`}
      trackingListName={titleConfig.tracking}
      trackingPageName={trackingPageName}
      filters={filters}
    />
  )
}

export default MerchandiseBestOfCategoryCarousel
